import { zhHK } from "../../../../date-fns/locale/zh-HK.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    zhHK
  }
};